import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';

import OutputText from '@ey/canvascoreservices/OutputText';

const RoleColumn = ({item}) => {
	const text = item.isInternal && item?.roleName !== undefined ? item.roleName : labels.notApplicable;

	return (
		<OutputText body2 light ellipsis title={text}>
			{text}
		</OutputText>
	);
};

export const config = (labels) => ({
	id: contactListColumnIds.role,
	label: labels.columnRole,
	propName: 'role',
	width: 'minmax(var(--px-210), var(--px-300))',
	sortBy: ['roleId', 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <RoleColumn {...props} />;
	}
});
